import {
    IconDevice5,
    IconDevice7,
    IconDevice9,
    IconDevice14,
    IconDevice15,
    IconDevice16,
    IconDevice17,
    IconDeviceMobil,
    IconDeviceFixed
} from "../components/buttons/IconButtons";

export const deviceTypeKeyNameEnum = {
    MANTRA_MFSTAB_II: 1,
    PDA_CARIBE_PL50L: 2,
    TELPO_F6: 3,
    TELPO_TPS_980: 4,
    TELPO_TPS_450: 5,
    TELPO_K5: 6,
    TELPO_F10: 7,
    TELPO_F6_T: 8,
    TELPO_K10: 9,
    VERIDAS_1FA: 10,
    VERIDAS_2FA: 11,
    CAMERA_LPR: 12,
    ANTENNA_RFID: 13,
    ARATEK_BM7550: 14,
    ARATEK_BA8300: 15,
    ARATEK_BM5510: 16,
    ARATEK_BD8500: 17,
};

export const getDeviceTypeById = (id) => {
    const found = Object.entries(DEVICE_TYPE_MODEL).find(
        ([, value]) => value?.id === id
    );
    return found ? found[1] : null;
};

export const DEVICE_TYPE_MODEL = {
    MANTRA_MFSTAB_II: {
        id: deviceTypeKeyNameEnum.MANTRA_MFSTAB_II,
        trans: "MANTRA MFSTAB II",
        icon: IconDeviceFixed,
    },
    PDA_CARIBE_PL50L: {
        id: deviceTypeKeyNameEnum.PDA_CARIBE_PL50L,
        trans: "PDA CARIBE PL50L",
        icon: IconDeviceFixed,
    },
    TELPO_F6: {
        id: deviceTypeKeyNameEnum.TELPO_F6,
        trans: "TELPO F6",
        icon: IconDeviceFixed,
    },
    TELPO_TPS_980: {
        id: deviceTypeKeyNameEnum.TELPO_TPS_980,
        trans: "TELPO TPS 980",
        icon: IconDevice7,
    },
    TELPO_TPS_450: {
        id: deviceTypeKeyNameEnum.TELPO_TPS_450,
        trans: "TELPO TPS 450",
        icon: IconDevice5,
    },
    TELPO_K5: {
        id: deviceTypeKeyNameEnum.TELPO_K5,
        trans: "TELPO K5",
        icon: IconDevice9,
    },
    TELPO_F10: {
        id: deviceTypeKeyNameEnum.TELPO_F10,
        trans: "TELPO F10",
        icon: IconDevice7,
    },
    TELPO_F6_T: {
        id: deviceTypeKeyNameEnum.TELPO_F6_T,
        trans: "TELPO F6 T",
        icon: IconDeviceFixed,
    },
    TELPO_K10: {
        id: deviceTypeKeyNameEnum.TELPO_K10,
        trans: "TELPO K10",
        icon: IconDevice9,
    },
    VERIDAS_1FA: {
        id: deviceTypeKeyNameEnum.VERIDAS_1FA,
        trans: "VERIDAS 1FA",
        icon: IconDeviceMobil,
    },
    VERIDAS_2FA: {
        id: deviceTypeKeyNameEnum.VERIDAS_2FA,
        trans: "VERIDAS 2FA",
        icon: IconDeviceMobil,
    },
    CAMERA_LPR: {
        id: deviceTypeKeyNameEnum.CAMERA_LPR,
        trans: "Camera_lpr",
        icon: IconDeviceFixed,
    },
    ANTENNA_RFID: {
        id: deviceTypeKeyNameEnum.ANTENNA_RFID,
        trans: "antena_rfid",
        icon: IconDeviceFixed,
    },
    ARATEK_BM7550: {
        id: deviceTypeKeyNameEnum.ARATEK_BM7550,
        trans: "Aratek BM 7550",
        icon: IconDevice14,
    },
    ARATEK_BA8300: {
        id: deviceTypeKeyNameEnum.ARATEK_BA8300,
        trans: "Aratek BA 8300",
        icon: IconDevice15,
    },
    ARATEK_BM5510: {
        id: deviceTypeKeyNameEnum.ARATEK_BM5510,
        trans: "Aratek BM 5510",
        icon: IconDevice16,
    },
    ARATEK_BD8500: {
        id: deviceTypeKeyNameEnum.ARATEK_BD8500,
        trans: "ARATEK BD8500",
        icon: IconDevice17,
    },
};
